import { WorkLogPage } from "../../../model/work-log/WorkLogPage/WorkLogPage";

export const FN70S01WorkLogSearch = () => {
  return <WorkLogPage type={"root"} />;
};
